import { useEffect, useState } from 'react';
import { VIEWPORT_SIZES } from '@/lib/constants';

export default function useViewportSize() {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [breakpoint, setBreakpoint] = useState<Breakpoint>('xs');

  useEffect(() => {
    const ro = new ResizeObserver(([entry]) => {
      const width = entry.contentRect.width;

      setWidth(width);
      setHeight(window.innerHeight);

      if (width >= VIEWPORT_SIZES['2xl']) {
        setBreakpoint('2xl');
      } else if (width >= VIEWPORT_SIZES.xl) {
        setBreakpoint('xl');
      } else if (width >= VIEWPORT_SIZES.lg) {
        setBreakpoint('lg');
      } else if (width >= VIEWPORT_SIZES.md) {
        setBreakpoint('md');
      } else if (width >= VIEWPORT_SIZES.sm) {
        setBreakpoint('sm');
      } else {
        setBreakpoint('xs');
      }
    });

    ro.observe(document.body);

    return () => ro.disconnect();
  }, []);

  return {
    breakpoint,
    height,
    width,
  };
}
